import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ExtendedParametersTabsEnum, RemoteDiagnosticsUseCasesStore } from '@store';

@Component({
  selector: 'app-extended-parameters-tabs',
  templateUrl: './extended-parameters-tabs.component.html',
  styleUrls: ['./extended-parameters-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExtendedParametersTabsComponent implements OnInit {
  readonly extendedParametersTabsEnum = ExtendedParametersTabsEnum;
  gatewaySerial: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    protected remoteDiagnosticsUseCasesStore: RemoteDiagnosticsUseCasesStore
  ) {}

  ngOnInit(): void {
    this.gatewaySerial = this.activatedRoute.snapshot.queryParams['gatewaySerial'];
  }
}
